import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="nav"
export default class extends Controller {
  static targets = ["nav", "backyardNav", "navText"];
  connect() {
    const nav = this.backyardNavTarget;
    const navStatus = nav.getAttribute("aria-expanded");
    window.addEventListener("resize", () => this.checkScreenWidth());
  }

  updateNavTextVisibility(isExpanded) {
    this.navTextTargets.forEach((item) => {
      item.classList.toggle("sr-only", !isExpanded);
    });
  }

  checkScreenWidth() {
    const isCollapsed = this.data.get("collapsed") === "true";
    const nav = this.backyardNavTarget;

    if (window.innerWidth < 800) {
      if (isCollapsed) {
        nav.setAttribute("aria-expanded", false);
        this.updateNavTextVisibility(false);
      }
    }
  }
}
